// extracted by mini-css-extract-plugin
module.exports = {"productDescriptionTab":"ProductDetailsTabs_productDescriptionTab__h45rg","tabsContainer":"ProductDetailsTabs_tabsContainer__CHVKS"};